const SIDEBAR_WIDTH = "450px";

export default {
  position: "absolute",
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  width: "100vw",
  height: "100vh",

  "@media print": {
    // Avoid an unwanted blank second page when printing in Chrome.
    // This started happening after the material ui upgrade to v7.
    // Firefox/Edge don't have this unwanted second page.
    breakAfter: "avoid !important",

    // Our theme hides mui components when printing.
    // However, we want THIS to show.
    visibility: "visible !important",
  },

  "& .mapboxgl-control-container": {
    display: "none",
  },

  "@media screen": {
    // When we enter print preview mode, we adjust some things based
    // on the class attributes the code adds to the <body> element.
    //
    // We use calc() to center the map in the space to the right
    // of the search/components region.

    "body.letter &": {
      marginLeft: `calc(${SIDEBAR_WIDTH} + (100vw - ${SIDEBAR_WIDTH} - 8.5in)/2) !important`,
    },

    "body.legal &": {
      marginLeft: `calc(${SIDEBAR_WIDTH} + (100vw - ${SIDEBAR_WIDTH} - 8.5in)/2) !important`,
    },

    "body.letter.landscape &": {
      marginLeft: `calc(${SIDEBAR_WIDTH} + (100vw - ${SIDEBAR_WIDTH} - 11in)/2) !important`,
    },

    "body.legal.landscape &": {
      marginLeft: `calc(${SIDEBAR_WIDTH} + (100vw - ${SIDEBAR_WIDTH} - 14in)/2) !important`,
    },
  },
};
